<ng-container *transloco="let t;">

  <div class="p-mb-4" [ngClass]="{'card-disabled': disabled === true }">
    <p-card>
      <div class="p-grid">
        <div class="p-col-8">
          <h2 *ngIf="!isMoveMode()">{{ t('common.labels.participants') }}</h2>
          <h2 *ngIf="isMoveMode()">{{ t('common.labels.moderators') }} / {{ t('common.labels.observers') }}</h2>
        </div>
        <div class="p-col-4 p-text-right" *ngIf="inEdit === true">
          <button *ngIf="canEditParticipants() === true" (click)="addParticipant()" pButton type="button" [label]="t('common.labels.add')" icon="pi pi-plus" class="p-button-secondary p-button-sm p-button-outlined" [disabled]="(submitting === true) ? true : null"></button>
        </div>
      </div>

      <p-table [value]="users">
        <ng-template pTemplate="header">
          <tr>
            <th *ngIf="isMoveMode()"></th>
            <th *ngIf="auth.isSuperUser()" pSortableColumn="id">{{ t('common.labels.id') }}
                <p-sortIcon field="id"></p-sortIcon>
            </th>
            <th pSortableColumn="roleName">{{ t('common.labels.type') }}
                <p-sortIcon field="roleName"></p-sortIcon>
            </th>
            <th pSortableColumn="lastname">{{ t('common.labels.lastname') }}
                <p-sortIcon field="lastname"></p-sortIcon>
            </th>
            <th pSortableColumn="firstname">{{ t('common.labels.firstname') }}
                <p-sortIcon field="firstname"></p-sortIcon>
            </th>
            <th pSortableColumn="mobile">{{ t('common.labels.mobile') }}
                <p-sortIcon field="mobile"></p-sortIcon>
            </th>
            <th pSortableColumn="email">{{ t('common.labels.email') }}
                <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th><fa-icon [icon]="faCommentSlash" [pTooltip]="t('common.labels.is_silent_observer')"></fa-icon></th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-participant>
            <tr *ngIf="!isMoveMode() || participant.temp === true">
              <td *ngIf="isMoveMode()">
                <ng-container *ngIf="getAppointmentInfoType(participant) as type">
                  <fa-icon *ngIf="type === 'available'" [ngClass]="type" [icon]="faAvailable" [pTooltip]="t('common.labels.available')"></fa-icon>
                  <fa-icon *ngIf="type === 'not-available'" [ngClass]="type" [icon]="faNotAvailable" [pTooltip]="t('move_order.labels.not-available')"></fa-icon>
                  <fa-icon *ngIf="type === 'blocked'" [ngClass]="type" [icon]="faBlocked" [pTooltip]="t('move_order.labels.blocked')"></fa-icon>
                  <fa-icon *ngIf="type === 'location'" [ngClass]="type" [icon]="faMapMarkerTimes" [pTooltip]="t('move_order.labels.location')"></fa-icon>
                </ng-container>
              </td>
              <td *ngIf="auth.isSuperUser()">{{ participant.id }}</td>
              <td>{{ participant.role?.translated_rolename }}</td>
              <td>{{ participant.lastname }}</td>
              <td>{{ participant.firstname }}</td>
              <td>{{ participant.mobile }}</td>
              <td>{{ participant.email }}</td>
              <td><fa-icon *ngIf="participant.silentobserver === true" [icon]="faCommentSlash" [pTooltip]="t('common.labels.is_silent_observer')"></fa-icon></td>
              <td class="p-text-right" style="min-width: 120px;">
                <ng-container *ngIf="inEdit !== true && canResendEmail() === true">
                  <button withRight="admin.planning-orders.edit" *ngIf="hasInfomailRole(participant)" pButton type="button" (click)="onResendInvitation(participant.role, participant, 'infomail')" icon="pi pi-info" [pTooltip]="t('ac_persons.resend_infomail')" tooltipPosition="left" class="p-button-outlined p-ml-2"></button>
                  <button withRight="admin.planning-orders.edit" *ngIf="hasInvitationRole(participant)" pButton type="button" (click)="onResendInvitation(participant.role, participant)" icon="pi pi-envelope" [pTooltip]="t('ac_persons.resend_invitation')" tooltipPosition="left" class="p-button-outlined p-ml-2"></button>
                </ng-container>
                <ng-container *ngIf="inEdit === true && canEditParticipants() === true">
                  <button pButton (click)="editParticipant(participant)" type="button" icon="pi pi-pencil" class="p-button-outlined p-ml-2" [disabled]="(submitting === true) ? true : null"></button>
                  <button pButton (click)="onStartDeleteParticipant(participant)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" [disabled]="(submitting === true) ? true : null"></button>
                </ng-container>
                <ng-container *ngIf="inEdit !== true && auth.isSuperUser() === true && participant.directlink">
                  <button pButton (click)="copyDirectLink(participant)" type="button" icon="pi pi-reply" class="p-button-outlined p-ml-2" [pTooltip]="t('common.labels.copy_directlink')" tooltipPosition="left"></button>
                </ng-container>
              </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="7">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
      <p *ngIf="isMoveMode()" class="p-mt-4 p-ml-2 p-text-small">
        <fa-icon [icon]="faAvailable" class="available"></fa-icon> {{ t('common.labels.available') }}
        <fa-icon [icon]="faNotAvailable" class="not-available p-ml-4"></fa-icon> {{ t('move_order.labels.not-available') }}
        <fa-icon [icon]="faMapMarkerTimes" class="location p-ml-4"></fa-icon> {{ t('move_order.labels.location') }}
        <fa-icon [icon]="faBlocked" class="blocked p-ml-4"></fa-icon> {{ t('move_order.labels.blocked') }}<br>
        {{ t('move_order.labels.hint') }}
      </p>
    </p-card>
  </div>

  <p-dialog [header]="t('common.labels.add_participant')" [(visible)]="dialogVisible" [style]="{width: '80vw'}" [draggable]="false" [modal]="true">
    <form (submit)="saveParticipant()">
      <div>
        <p class="p-text-right">
          <button *ngIf="formMode === formModes.Form" type="button" pButton [label]="t('partials.employee_search.topline')" icon="pi pi-search" (click)="onOpenEmployeeSearch()" [disabled]="disabled" class="p-button-sm p-button-secondary p-button-outlined"></button>
        </p>

        <div class="p-grid">
          <div class="p-col-4">
            <app-form-control [cid]="'role'" [control]="participantForm.get('role')" [type]="'select'" [options]="optionsRoles" optionLabel="translated_rolename" [label]="t('common.labels.role')"></app-form-control>
          </div>
          <div class="p-col-4" *ngIf="formMode === formModes.Select">
            <app-form-control [cid]="'user'" [control]="participantForm.get('user')" [type]="'select'" [options]="optionsUsers" optionLabel="fullname_reverse" [filter]="true" [label]="t('common.labels.user')"></app-form-control>
          </div>
          <div class="p-col-4" *ngIf="showSilentObserver === true">
            <div style="margin-top:27px">
              <app-form-control [cid]="'silentobserver'" [control]="participantForm.get('silentobserver')" [type]="'checkbox'" [label]="t('common.labels.is_silent_observer')"></app-form-control>
            </div>
          </div>
        </div>

        <div class="p-grid" *ngIf="formMode === formModes.Form">
          <div class="p-col-4">
            <app-form-control [cid]="'gender'" [control]="participantForm.get('gender')" [type]="'select'" [options]="optionsSalutations" [label]="t('common.labels.gender')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'firstname'" [control]="participantForm.get('firstname')" [type]="'input'" [label]="t('common.labels.firstname')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'lastname'" [control]="participantForm.get('lastname')" [type]="'input'" [label]="t('common.labels.lastname')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'email'" [control]="participantForm.get('email')" [type]="'input'" [label]="t('common.labels.email')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'phone'" [control]="participantForm.get('phone')" [type]="'input'" [label]="t('common.labels.phone')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'mobile'" [control]="participantForm.get('mobile')" [type]="'input'" [label]="t('common.labels.mobile')"></app-form-control>
          </div>
        </div>

      </div>
      <p-footer>
        <div class="p-text-right">
          <button pButton (click)="cancelParticipant()" type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-button-secondary p-mr-2"></button>
          <button pButton type="submit" label="{{ t('common.ok') }}" class="p-button-success"></button>
        </div>
      </p-footer>
    </form>
  </p-dialog>

  <p-dialog [header]="t('common.really_delete')" [(visible)]="deleteDialogVisible" styleClass="dialog-full" [draggable]="false" [modal]="true">
    <form (submit)="deleteParticipant()">
      <p [innerHtml]="t('common.messages.really_delete', { value: deleteDialogUser?.fullname })"></p>
      <div *ngIf="hasAvailabilities() === true && move !== true">
        <p>{{ t('order_detail.availability_mode') }}</p>
        <app-form-control [cid]="'resourcemode'" [control]="deleteForm.get('resourcemode')" [type]="'radiogroup'" [options]="optionsResourceModes" [hideLabel]="true"></app-form-control>
      </div>
      <p-footer>
        <div class="p-text-right">
          <button pButton (click)="cancelDeleteParticipant()" type="button" label="{{ t('common.labels.no') }}" icon="pi pi-times" class="p-button-primary p-mr-2"></button>
          <button pButton type="submit" label="{{ t('common.labels.yes') }}" icon="pi pi-check" class="p-button-primary"></button>
        </div>
      </p-footer>
    </form>
  </p-dialog>

  <app-employee-search #employeesearch (select)="onSelectEmployee($event)"></app-employee-search>

</ng-container>
